import { ApiHeader } from '@/models/http/ApiHeader';
import { ApiResponse } from '@/models/http/ApiResponse';
import { ContentType } from '@/models/http/ContentType';
import { MethodType } from '@/models/http/MethodType';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export default class HttpService {
     
     private static readonly contentTypes = [
          { type: ContentType.Json, value: 'application/json' },
          { type: ContentType.FormData, value: 'multipart/form-data' }
     ]

     public static async send<T>(url: string, methodType: MethodType, data?: any, headers?: ApiHeader, signal?: AbortSignal) : Promise<ApiResponse<T>> {

          const requestOptions: AxiosRequestConfig = {
               method: methodType,
               headers: this.getHeaders(headers),
               data: this.getBody(data, headers)
          };

          const response = await axios(url, requestOptions);

          const parsedResponse = this.parseResponse<T>(response);

          return parsedResponse;
     }

     private static parseResponse<T>(response: AxiosResponse) : ApiResponse<T> {
          const headers = new Headers();
          Object.entries(response.headers).forEach(([key, value]) => {
               headers.append(key, value as string);
          });

          const result: ApiResponse<T> = {
               status: response.status,
               statusText: response.statusText,
               data: response.data,
               headers: headers
          }

          return result;
     }

     private static getBody = (data?: any, headers?: ApiHeader) : string | FormData | undefined => {
          if (data) {
               if (headers && headers.contentType === ContentType.FormData) {
                    const formData = new FormData();

                    const appendFormData = (formData: FormData, data: any) => {
                         Object.keys(data).forEach(key => {
                             const value = data[key];
                     
                             if (value instanceof File) {
                                 formData.append(key, value);
                             } else if (value !== null && value !== undefined) {
                                 formData.append(key, String(value));
                             }
                         });
                     };
                 
                    appendFormData(formData, data);

                    return formData;
               }

               return JSON.stringify(data);
          }
          
          return undefined;
     }

     private static getHeaders = (headers?: ApiHeader): Record<string, string> => {
          const contentType = HttpService.contentTypes.find(ct => ct.type === headers?.contentType ? headers.contentType : ContentType.Json)!.value;

          const headersRequest: Record<string, string> = {
               'Content-Type': contentType
           } as Record<string, string>;
       
           return headersRequest;
     }
}